export default {
  SET_MYHOME_PROJECT_LIST(state, data) {
    state.projectList = data
  },
  SET_MYHOME_WORKREQUEST_LIST(state, data) {
    state.workRequestList = data
  },
  SET_MYHOME_NOTICE_LIST(state, data) {
    state.noticeList = data
  },
  SET_MYHOME_QNA_LIST(state, data) {
    state.qnaList = data
  },
}



// WEBPACK FOOTER //
// ./src/vuex/home/myHomeMutation.js